import ApiClient from './ApiClient';

class AppointmentsAPI extends ApiClient {
  constructor() {
    super('appointments', { accountScoped: true });
  }

  get exportUrl() {
    return `${this.url}/export`;
  }
}

export default new AppointmentsAPI();
